module.exports = __webpack_public_path__ + "img/vipIcon.5823ed08.png";